import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import About from "../views/about/index.vue"
import news from "../views/news/index.vue"
import newsInfo from "../views/news/new_info.vue"
import feedback from "../views/feedback/index.vue"
import people from "../views/people/index.vue"
import project from "../views/project/index"
import projectInfo from "../views/project/project_info.vue"

import culture from "../views/culture/index.vue"

Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  mode: 'history', // 去掉url中的#
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/culture',
      name: 'culture',
      component: culture
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/newsInfo',
      name: 'newsInfo',
      component: newsInfo
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: feedback
    },
    {
      path: '/people',
      name: 'people',
      component: people
    },
    {
      path: '/project',
      name: 'project',
      component: project
    },
    {
      path: '/project_info',
      name: 'projectInfo',
      component: projectInfo
    },
  ]
})
